import {
    MONUMPAY_WITHDRAWAL,
    MONUMPAY_WITHDRAWAL_SUCCESS,
    MONUMPAY_WITHDRAWAL_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
    loading: false,
    momunpay: null,
};

const monumpayPayoutReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case MONUMPAY_WITHDRAWAL:
            return { ...state, loading: true };
        case MONUMPAY_WITHDRAWAL_SUCCESS:
            return {
                ...state,
                momunpay: action?.payload,
                loading: false,
            };
        case MONUMPAY_WITHDRAWAL_FAILURE:
            return { ...state, loading: false };
        default:
            return state;
    }
};

export default monumpayPayoutReducer;
